import React, { useState } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import styles from './ShareQuoteModal.module.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  IoArrowBackCircleOutline,
  IoCloseCircleOutline,
  IoLogoVk,
} from 'react-icons/io5';
import {
  createMessageWithLink,
  createMessageWithLinkAndText,
  createMessageWithLinkTextAndIcons,
  handleShareTelegram,
  handleShareVK,
  handleShareWhatsApp,
} from './utils';
import { MdDoneOutline } from 'react-icons/md';
import { BsCopy, BsTelegram, BsWhatsapp } from 'react-icons/bs';

export const ShareQuoteModal = ({
  handleClose,
  isOpen,
  quoteItem,
  quoteData,
}) => {
  const [isCopied, setCopied] = useState(false);
  const [initialState, setInitialState] = useState(true);
  const [variant, setVariant] = useState('link');
  const [textAreaValue, setTextAreaValue] = useState('');

  const { quote_id, title: quoteTitle } = quoteItem;
  const title = quoteTitle ? quoteTitle : `Геоподборка ${quote_id}`;

  const onClose = () => {
    setInitialState(true);
    setVariant('link');
    handleClose();
  };

  function handleSwitchSendType() {
    setInitialState(false);
    setVariant('link');
    setTextAreaValue(createMessageWithLink(title, quote_id));
  }

  function handleCopy() {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <Modal
      style={{
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        overflow: 'auto',
      }}
      className={styles.modalContainer}
      onClose={onClose}
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={`${styles.boxContainer}`}>
        {!initialState ? (
          <IoArrowBackCircleOutline
            style={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              color: 'gray',
              cursor: 'pointer',
            }}
            onClick={() => {
              setInitialState(true);
            }}
            size={30}
          />
        ) : null}
        {initialState && (
          <div>
            <div className={styles.header}>
              <Typography
                style={{ marginBottom: '20px', color: '#333' }}
                className={styles.modalTitle}
                variant="h6"
                component="h2"
              >
                Как вы хотите поделиться?
              </Typography>
              <IoCloseCircleOutline
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  color: 'gray',
                  cursor: 'pointer',
                }}
                onClick={onClose}
                size={30}
              />
            </div>
            <div className={styles.link} onClick={handleSwitchSendType}>
              <BsCopy className={styles.icon} style={{ color: '#5c6672' }} />
              <span className={styles.iconText}>Ссылка и текст</span>
            </div>
          </div>
        )}

        {/* ссылка и текст*/}
        {!initialState && (
          <>
            <div className={styles.header}>
              <Typography
                style={{ marginBottom: '20px', color: '#333' }}
                className={styles.modalTitle}
                variant="h6"
                component="h2"
              >
                Поделиться ссылкой и текстом
              </Typography>
              <IoCloseCircleOutline
                onClick={onClose}
                className={styles.closeButton}
                size={30}
              />
            </div>
            <div className={styles.buttons}>
              <div
                onClick={() => {
                  setTextAreaValue(createMessageWithLink(title, quote_id));
                  setVariant('link');
                  setCopied(false);
                }}
                className={`${styles.button} ${
                  variant === 'link' ? styles.buttonActive : ''
                }
                `}
              >
                Ссылка
              </div>
              <div
                onClick={() => {
                  setTextAreaValue(
                    createMessageWithLinkAndText(
                      quoteData.response.tours,
                      title,
                      quote_id
                    )
                  );
                  setVariant('text');
                  setCopied(false);
                }}
                className={`${styles.button} ${
                  variant === 'text' ? styles.buttonActive : ''
                }
                `}
              >
                Текст
              </div>

              <div
                onClick={() => {
                  setTextAreaValue(
                    createMessageWithLinkTextAndIcons(
                      quoteData.response.tours,
                      title,
                      quote_id
                    )
                  );
                  setVariant('icons');
                  setCopied(false);
                }}
                className={`${styles.button} ${
                  variant === 'icons' ? styles.buttonActive : ''
                }
                `}
              >
                Иконки
              </div>
            </div>
            <div>
              <textarea
                onChange={(e) => {
                  setTextAreaValue(e.currentTarget.value);
                }}
                value={textAreaValue}
                className={styles.textarea}
              ></textarea>
              <CopyToClipboard text={textAreaValue}>
                <button
                  onClick={handleCopy}
                  className={`${styles.buttonCopy} ${
                    isCopied ? styles.success : ''
                  }`}
                >
                  {isCopied ? <MdDoneOutline /> : <BsCopy />}
                  {isCopied ? 'Скопировано' : 'Скопировать'}
                </button>
              </CopyToClipboard>
            </div>
          </>
        )}

        {/*// ссылки на мессенджеры*/}
        {initialState && (
          <div>
            <Typography
              style={{ margin: '20px 0', color: '#333' }}
              className={styles.modalTitle}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Поделиться в 1 клик
            </Typography>
            <button
              className={styles.link}
              onClick={() => handleShareWhatsApp(title, quote_id)}
            >
              <BsWhatsapp className={styles.icon} style={{ color: 'green' }} />
              <span className={styles.iconText}>WhatsApp</span>
            </button>

            <button
              className={styles.link}
              onClick={() => handleShareTelegram(title, quote_id)}
            >
              <BsTelegram
                className={styles.icon}
                style={{ color: '#23ade0' }}
              />
              <span className={styles.iconText}>Telegram</span>
            </button>

            <button
              className={styles.link}
              onClick={() => handleShareVK(title, quote_id)}
            >
              <IoLogoVk className={styles.icon} style={{ color: '#3e93d8' }} />
              <span className={styles.iconText}>ВКонтакте</span>
            </button>
          </div>
        )}
      </Box>
    </Modal>
  );
};
